const lunr = require('lunr');
const STOPWORDS = ['a', 'and', 'the', 'but', 'or', 'is', 'at', 'be', 'by'];

var index = lunr(function () {
  this.field('title', {boost: 10});
  this.field('contents');
  this.field('summary');
  this.field('tokens');
});
lunr.stopWordFilter = lunr.generateStopWordFilter(STOPWORDS);
delete lunr.Pipeline.registeredFunctions.stopWordFilter;
lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter');

const addItemToIndex = function(item) {
  if (item.hide && !item.searchable) return;
  var doc = {
    id: item.path,
    title: item.fullTitle || item.title,
    summary: item.summary,
    contents: item.contents,
  }
  doc.tokens = doc.title.replace(/\W/, ' ');
  index.add(doc);
  if (item.children) item.children.forEach(function(c) { addItemToIndex(c) });
}

self.addEventListener('message', function (e) {
  e.data.items.forEach(function(item) {
    addItemToIndex(item);
  });
  self.postMessage(JSON.stringify({
    requestID: e.data.requestID,
    index: index.toJSON()
  }));
}, false);



//////////////////
// WEBPACK FOOTER
// ./src/app/lunr_worker.js
// module id = ./src/app/lunr_worker.js
// module chunks = main